function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { AccountMembershipRole, Module, ReviewType, useGetAccountQuery } from '~/types/types';
import { getMembershipRoles, isAccountAdminForAccount } from '~/functions/membership-role';
export function usePortfolioReviewContext() {
  var _useGetAccountQuery = useGetAccountQuery(),
    result = _useGetAccountQuery.result,
    loading = _useGetAccountQuery.loading;
  var account = computed(function () {
    var _result$value;
    return (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.getAccount;
  });
  var hasReviewModule = computed(function () {
    var _account$value$module, _account$value, _account$value$module2;
    return (_account$value$module = (_account$value = account.value) === null || _account$value === void 0 ? void 0 : (_account$value$module2 = _account$value.modules) === null || _account$value$module2 === void 0 ? void 0 : _account$value$module2.includes(Module.Review)) !== null && _account$value$module !== void 0 ? _account$value$module : false;
  });
  var membershipRoles = computed(function () {
    return getMembershipRoles(account.value);
  });
  var isReviewer = computed(function () {
    return hasReviewModule.value && membershipRoles.value.includes(AccountMembershipRole.Reviewer) && !membershipRoles.value.includes(AccountMembershipRole.Editor);
  });
  var hasReviewerRole = computed(function () {
    return hasReviewModule.value && membershipRoles.value.includes(AccountMembershipRole.Reviewer);
  });
  var isEditor = computed(function () {
    return membershipRoles.value.includes(AccountMembershipRole.Editor);
  });
  var isAccountAdmin = computed(function () {
    return isAccountAdminForAccount(account.value);
  });
  var showReviewerShell = computed(function () {
    return isReviewer.value;
  });
  var portfolioLandingPath = computed(function () {
    var _account$value2, _account$value2$booke, _account$value3, _account$value3$modul, _account$value4, _account$value4$booke;
    if (showReviewerShell.value) {
      return '/portfolio/review';
    }
    if ((_account$value2 = account.value) !== null && _account$value2 !== void 0 && (_account$value2$booke = _account$value2.bookedModules) !== null && _account$value2$booke !== void 0 && _account$value2$booke.includes(Module.Esg) || (_account$value3 = account.value) !== null && _account$value3 !== void 0 && (_account$value3$modul = _account$value3.modules) !== null && _account$value3$modul !== void 0 && _account$value3$modul.includes(Module.Esg)) {
      return '/portfolio/dashboard';
    }
    if ((_account$value4 = account.value) !== null && _account$value4 !== void 0 && (_account$value4$booke = _account$value4.bookedModules) !== null && _account$value4$booke !== void 0 && _account$value4$booke.includes(Module.ImpactGoal)) {
      return '/portfolio/impactGoalList';
    }
    return '/portfolio/metrics';
  });
  return {
    account: account,
    loading: loading,
    hasReviewModule: hasReviewModule,
    membershipRoles: membershipRoles,
    isReviewer: isReviewer,
    hasReviewerRole: hasReviewerRole,
    isEditor: isEditor,
    isAccountAdmin: isAccountAdmin,
    showReviewerShell: showReviewerShell,
    portfolioLandingPath: portfolioLandingPath
  };
}

/** Redirect reviewer-only users off non-review routes; editor-only users off /portfolio/review. */
export function useReviewRouteGuards(options) {
  var router = useRouter();
  var route = useRoute();
  var _usePortfolioReviewCo = usePortfolioReviewContext(),
    loading = _usePortfolioReviewCo.loading,
    hasReviewModule = _usePortfolioReviewCo.hasReviewModule,
    showReviewerShell = _usePortfolioReviewCo.showReviewerShell,
    hasReviewerRole = _usePortfolioReviewCo.hasReviewerRole,
    isEditor = _usePortfolioReviewCo.isEditor,
    portfolioLandingPath = _usePortfolioReviewCo.portfolioLandingPath;
  watch(function () {
    return route.path;
  }, function (path) {
    if (loading.value || !hasReviewModule.value) {
      return;
    }
    var isReviewRoute = path.startsWith('/portfolio/review');
    var isPortfolioRoute = path.startsWith('/portfolio');
    if (showReviewerShell.value) {
      if (isPortfolioRoute && !isReviewRoute) {
        router.replace('/portfolio/review');
      } else if (options !== null && options !== void 0 && options.guardAdminAccounts && path === '/admin/accounts') {
        router.replace('/portfolio/review');
      }
      return;
    }
    if (isEditor.value && !hasReviewerRole.value && isReviewRoute) {
      router.replace(portfolioLandingPath.value);
    }
  }, {
    immediate: true
  });
}
export function isReviewVentureOpenForReview(status) {
  var key = status || 'AWAITING_REVIEW';
  return key === 'AWAITING_REVIEW' || key === 'EDITS_REQUESTED';
}
export function isReviewRequestFullyApproved(ventures) {
  var rows = ventures !== null && ventures !== void 0 ? ventures : [];
  return rows.length > 0 && rows.every(function (venture) {
    return (venture.status || 'AWAITING_REVIEW') === 'APPROVED';
  });
}
export function countReviewVentureStatuses(ventures) {
  var counts = {
    APPROVED: 0,
    EDITS_REQUESTED: 0,
    AWAITING_REVIEW: 0
  };
  var _iterator = _createForOfIteratorHelper(ventures !== null && ventures !== void 0 ? ventures : []),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var venture = _step.value;
      var key = venture.status || 'AWAITING_REVIEW';
      if (key in counts) {
        counts[key] += 1;
      } else {
        counts.AWAITING_REVIEW += 1;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return counts;
}
export function formatReviewAggregateStatus(ventures) {
  if (!(ventures !== null && ventures !== void 0 && ventures.length)) {
    return '—';
  }
  var counts = countReviewVentureStatuses(ventures);
  var parts = [];
  if (counts.APPROVED) {
    parts.push("".concat(counts.APPROVED, " approved"));
  }
  if (counts.EDITS_REQUESTED) {
    parts.push("".concat(counts.EDITS_REQUESTED, " edits requested"));
  }
  if (counts.AWAITING_REVIEW) {
    parts.push("".concat(counts.AWAITING_REVIEW, " awaiting"));
  }
  return parts.join(', ');
}

/** v1: only Theory of Change; extend when new review types ship. */
export function formatReviewTypeLabel(reviewType, t) {
  var key = reviewType !== null && reviewType !== void 0 ? reviewType : ReviewType.TheoryOfChange;
  return t(key);
}

/** Soft-tint chip classes — aligned with `ix/chip/MembershipRole.vue`. */
export function reviewStatusChipClasses(status) {
  var base = 'review-status-chip';
  switch (status) {
    case 'APPROVED':
      return "".concat(base, " review-status-chip--approved");
    case 'EDITS_REQUESTED':
      return "".concat(base, " review-status-chip--edits");
    case 'SUBMITTED':
      return "".concat(base, " review-status-chip--submitted");
    case 'META':
      return "".concat(base, " review-status-chip--meta");
    case 'IN_PROGRESS':
    case 'AWAITING_REVIEW':
    default:
      return "".concat(base, " review-status-chip--neutral");
  }
}

/** Keys match `components/review/StatusChip.vue` i18n. */
export function formatReviewStatusLabel(status, t) {
  switch (status) {
    case 'APPROVED':
      return t('approved');
    case 'EDITS_REQUESTED':
      return t('editsRequested');
    case 'SUBMITTED':
      return t('submitted');
    default:
      return t('awaiting');
  }
}

/** Lowercase labels for aggregate progress chips (`{count} approved`). */
export function formatReviewStatusCountLabel(status, t) {
  switch (status) {
    case 'APPROVED':
      return t('approvedCount');
    case 'EDITS_REQUESTED':
      return t('editsRequestedCount');
    default:
      return t('awaitingCount');
  }
}